module.exports = __webpack_public_path__ + "img/telegram-logo.png";